import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    AddEditSchoolDetails: {},
}

const SchoolSlice = createSlice({
    name: "SchoolSlice",
    initialState,

    reducers: {
        SchoolData(state, action) {
            return {
                AddEditSchoolDetails: action.payload.AddEditSchoolDetails,
            };
        }
    }
})
export const { SchoolData } = SchoolSlice.actions;
export default SchoolSlice.reducer;